<template>
	<div v-loading="loadingDM">
		<div v-if="hasGetTableDataModel && hasGetData">
			<div class="row border-bottom mb-3" v-for="(line,lineIndex) in fields" :key="lineIndex">
				<div :class="'col-'+key.col" v-for="(key,itemIndex) in line" :key="itemIndex">
					<dl>
						<dt
							class="info-title"
							:key="itemIndex+'k'"
							v-if="key.name!='null'"
						>{{dataModels[dataModelName][key.name].show_name}}</dt>
						<dd class="info-content" :class="'col-tb-'+key.col" :key="itemIndex+'c'" :colspan="key.col">
							<field-show
								:record-model="dataModelName"
								:field-info="dataModels[dataModelName][key.name]"
								:value="info[key.name]"
								:field-key="key"
								:params="key.params"
							></field-show>
						</dd>
					</dl>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FieldShow from "@/components/FieldShow.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import LoadDM from "@/mixins/LoadDM.js";

export default {
	mixins: [LoadDM],
	data() {
		return {
			loadings: {
				main: false,
			},
			info: {},
			styles: [],
			visible: false,
			everEdited: false,
			hasGetData: false,
		};
	},
	props: {
		dataModelName: {
			type: String,
			default: "",
		},
		recordId: {
			type: String,
			default: "",
		},
		show: {
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
			default: "name",
		},
		fields: {
			type: Array,
			default: function() {
				return [];
			},
		},
		handlerCtrller: {
			type: String,
			default: "curd",
		},
		autoLoad: {
			type: Boolean,
			default: true,
		},
	},

	mounted() {},
	methods: {
		handleFormEdited() {
			this.everEdited = true;
		},
		handleSelect() {},
		setData(data) {
			for (let k in data) {
				this.$set(this.info, k, data[k]);
			}
			this.hasGetData = true;
		},
		refreshData() {
			this.loadings.main = true;
			this.$axios
				.post(`/${this.handlerCtrller}/edit/${this.dataModelName}/${this.recordId}`)
				.then(json => {
					this.setData(json.data.info);
					this.loadings.main = false;
				})
				.catch(json => {
					this.loadings.main = false;
				});
		},
	},
	components: {
		FieldShow,
	},
	watch: {
		hasGetTableDataModel: {
			handler(val) {
				if (val) {
					if (this.autoLoad) {
						this.initInfo();
						this.refreshData();
					}
				}
			},
			immediate: true,
		},
	},
};
</script>
<style lang="scss" scoped>
.info-title {
	font-weight: bold;
}
.info-content {
	margin-top: 1em;
}
</style>
